import { Eye, X } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";

// Sticks under the TopBar whenever the current admin is in Preview-As mode.
// Lets them see which group they're previewing as and exit with one click.
export default function PreviewBanner() {
    const { user, refreshMe } = useAuth();
    const preview = user?.preview_groups || [];
    if (user?.role !== "admin" || preview.length === 0) return null;

    const exit = async () => {
        try {
            await api.delete("/admin/preview-as");
            toast.success("Exited preview mode");
            await refreshMe();
        } catch (e) {
            toast.error("Failed to exit preview");
        }
    };

    return (
        <div
            className="sticky top-16 z-20 bg-haevn-700 text-white border-b border-haevn-900"
            data-testid="preview-banner"
        >
            <div className="px-4 md:px-10 py-2 flex items-center justify-between gap-3">
                <div className="flex items-center gap-3 text-sm min-w-0">
                    <Eye size={15} strokeWidth={1.5} className="shrink-0" />
                    <span className="font-mono text-[10px] uppercase tracking-[0.2em] opacity-70 hidden sm:inline">
                        Previewing as
                    </span>
                    <span className="font-medium truncate" data-testid="preview-banner-group">
                        {preview.map((g) => g.title).join(", ")}
                    </span>
                </div>
                <button
                    onClick={exit}
                    data-testid="preview-banner-exit"
                    className="inline-flex items-center gap-1 text-xs uppercase tracking-[0.15em] font-mono opacity-80 hover:opacity-100"
                >
                    <X size={13} /> Exit preview
                </button>
            </div>
        </div>
    );
}
